import React, { useState } from 'react'
import axios from 'axios'
import pubsub from 'pubsub-js'
import { Button, Paper, Typography, FormControlLabel, Radio, RadioGroup, Modal, TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { questions } from './interviewQuestion'
import speeex_logo_modal from '../../../assets/images/logon.svg'
import {useHistory} from 'react-router-dom'

const RADIO_QUESTIONS = questions.filter((q) => q.type === 'radio')
const TEXT_QUESTIONS = questions.filter((q) => q.type === 'text')
const TOTAL_QUESTIONS = questions.length

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    boxShadow: theme.shadows[8],
    maxWidth: '80vw',
    maxHeight: '85vh',
    overflow: 'auto',
    position: 'relative',
  },
  header: {
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #dee2e6',
    padding: theme.spacing(3),
    textAlign: 'center',
    position: 'relative',
  },
  logo: {
    width: '100%',
    height: 80,
    marginBottom: theme.spacing(2),
    objectFit: 'contain',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.5rem',
    color: '#2c3e50',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: '0.95rem',
    color: '#6c757d',
    lineHeight: 1.5,
    maxWidth: '600px',
    margin: '0 auto',
  },
  content: {
    padding: theme.spacing(3),
    backgroundColor: 'white',
  },
  section: {
    marginBottom: theme.spacing(4),
    paddingBottom: theme.spacing(3),
    borderBottom: '1px solid #e9ecef',
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '1.1rem',
    color: '#495057',
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: '2px solid #dee2e6',
  },
  question: {
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(2),
    backgroundColor: '#f8f9fa',
    borderRadius: 6,
    border: '1px solid #e9ecef',
  },
  questionText: {
    fontWeight: 500,
    fontSize: '0.95rem',
    color: '#495057',
    marginBottom: theme.spacing(2),
    lineHeight: 1.4,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  radioOption: {
    backgroundColor: 'white',
    borderRadius: 4,
    padding: theme.spacing(0.5, 2),
    border: '1px solid #ced4da',
    transition: 'all 0.15s ease',
    flexShrink: 0,
    maxWidth: '100%',
    '&:hover': {
      borderColor: '#6c757d',
      backgroundColor: '#f8f9fa',
    },
  },
  radioOptionSelected: {
    borderColor: '#007bff',
    backgroundColor: '#e7f3ff',
  },
  selectControl: {
    width: '100%',
    marginTop: theme.spacing(0.5),
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
    },
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      borderRadius: 4,
      '&:hover fieldset': {
        borderColor: '#6c757d',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#007bff',
      },
    },
  },
  errorText: {
    color: '#dc3545',
    fontSize: '0.8rem',
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    backgroundColor: '#f8f9fa',
    borderTop: '1px solid #dee2e6',
    borderRadius: '0 0 8px 8px',
  },
  submitButton: {
    backgroundColor: '#28a745',
    color: 'white',
    fontWeight: 500,
    padding: theme.spacing(1, 3),
    borderRadius: 4,
    textTransform: 'none',
    fontSize: '0.9rem',
    '&:hover': {
      backgroundColor: '#218838',
    },
  },
  cancelButton: {
    backgroundColor: '#6c757d',
    color: 'white',
    fontWeight: 500,
    padding: theme.spacing(1, 3),
    borderRadius: 4,
    textTransform: 'none',
    fontSize: '0.9rem',
    '&:hover': {
      backgroundColor: '#5a6268',
    },
  },
  progressBar: {
    backgroundColor: '#f8f9fa',
    padding: theme.spacing(1.5),
    borderBottom: '1px solid #dee2e6',
  },
  progressText: {
    textAlign: 'center',
    color: '#6c757d',
    fontSize: '0.85rem',
    marginBottom: theme.spacing(1),
  },
  progressBarContainer: {
    width: '100%',
    height: '6px',
    backgroundColor: '#e9ecef',
    borderRadius: '3px',
    overflow: 'hidden',
  },
  progressBarFill: {
    height: '100%',
    backgroundColor: '#28a745',
    transition: 'width 0.3s ease',
  },
}));

const ResignIntervieModal = ({ gateMode = false, gateActive = false, onCompleted }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false)
  const [selectedAnswers, setSelectedAnswers] = useState(() =>
    RADIO_QUESTIONS.map((q) => (q.multiSelect ? [] : '')),
  )
  const [selectedAnswersError, setSelectedAnswersError] = useState(() =>
    new Array(RADIO_QUESTIONS.length).fill(false),
  )
  const [q8Other, setQ8Other] = useState('')
  const [q8OtherError, setQ8OtherError] = useState(false)
  const [inputAnswers, setInputAnswers] = useState(() =>
    new Array(TEXT_QUESTIONS.length).fill(''),
  )
  const router = useHistory();

  const isModalOpen = gateMode ? gateActive : open

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    if (gateMode) return
    setOpen(false)
  }
  
  const handleSubmit = (event) => {
    event.preventDefault()
    const updatedSelectedAnswersError = selectedAnswers.map((answer, i) => {
      const q = RADIO_QUESTIONS[i]
      if (q.multiSelect) return !Array.isArray(answer) || answer.length === 0
      return answer === ''
    })
    setSelectedAnswersError(updatedSelectedAnswersError)

    const textMissing = TEXT_QUESTIONS.some(
      (q, i) => q.required && !String(inputAnswers[i] ?? '').trim(),
    )
    const radioMissing = selectedAnswers.some((a, i) => {
      const q = RADIO_QUESTIONS[i]
      if (q.multiSelect) return !Array.isArray(a) || a.length === 0
      return a === ''
    })

    const q8Idx = RADIO_QUESTIONS.findIndex((q) => q.inputName === 'q8')
    const q8Vals = q8Idx >= 0 ? selectedAnswers[q8Idx] : []
    const needsQ8Other =
      q8Idx >= 0 &&
      RADIO_QUESTIONS[q8Idx].otherOptionValue &&
      Array.isArray(q8Vals) &&
      q8Vals.includes(RADIO_QUESTIONS[q8Idx].otherOptionValue)
    const q8OtherMissing = needsQ8Other && !String(q8Other).trim()
    setQ8OtherError(q8OtherMissing)

    if (radioMissing || textMissing || q8OtherMissing) {
      pubsub.publish('showNotification', {
        message: 'Ju lutemi plotësoni të gjitha fushat e detyrueshme.',
        type: 'error',
      })
      return
    }

    const body = {
      ...Object.fromEntries(
        RADIO_QUESTIONS.map((q, i) => [q.inputName, selectedAnswers[i]]),
      ),
      ...Object.fromEntries(
        TEXT_QUESTIONS.map((q, i) => [q.inputName, inputAnswers[i]]),
      ),
      q8Other: String(q8Other).trim(),
    }

    axios
      .post('resignInterview', body)
      .then((res) => {
        if (res.data.status === 'success') {
          pubsub.publish('showNotification', {
            message: 'Të dhënat janë ruajtur!',
            type: 'success'
          })
          if (!gateMode) {
            setOpen(false)
          }
          setSelectedAnswers(RADIO_QUESTIONS.map((q) => (q.multiSelect ? [] : '')))
          setSelectedAnswersError(new Array(RADIO_QUESTIONS.length).fill(false))
          setQ8Other('')
          setQ8OtherError(false)
          setInputAnswers(new Array(TEXT_QUESTIONS.length).fill(''))
          onCompleted?.()
          if (!gateMode) {
            router.go(0)
          }
        } else {
          pubsub.publish('showNotification', {
            message: res.data.message,
            type: 'error'
          })
        }
      })
      .catch((err) => {
        console.log('error', err)
      })
  }
  
  const handleRadioChange = (event, index) => {
    const newSelectedAnswers = [...selectedAnswers]
    newSelectedAnswers[index] = event.target.value
    setSelectedAnswers(newSelectedAnswers)

    const newSelectedAnswersError = [...selectedAnswersError]
    newSelectedAnswersError[index] = event.target.value === '' ? true : false
    setSelectedAnswersError(newSelectedAnswersError)
  }

  const handleInputChange = (event, index) => {
    const newInputAnswers = [...inputAnswers]
    newInputAnswers[index] = event.target.value
    setInputAnswers(newInputAnswers)
  }

  // Group questions by section
  const groupQuestionsBySection = () => {
    const sections = {}
    questions.forEach(question => {
      if (!sections[question.section]) {
        sections[question.section] = []
      }
      sections[question.section].push(question)
    })
    return sections
  }

  // Calculate completion percentage
  const calculateProgress = () => {
    const answeredQuestions =
      selectedAnswers.filter((answer, i) => {
        const q = RADIO_QUESTIONS[i]
        if (q.multiSelect) return Array.isArray(answer) && answer.length > 0
        return answer !== ''
      }).length +
      inputAnswers.filter((answer) => answer !== '').length
    return Math.round((answeredQuestions / TOTAL_QUESTIONS) * 100)
  }

  const sections = groupQuestionsBySection()
  const progress = calculateProgress()
  const answeredCount =
    selectedAnswers.filter((a, i) => {
      const q = RADIO_QUESTIONS[i]
      if (q.multiSelect) return Array.isArray(a) && a.length > 0
      return a !== ''
    }).length +
    inputAnswers.filter((a) => a !== '').length

  return (
    <div>
      {!gateMode && (
        <Button
          variant='contained'
          size='small'
          color='primary'
          style={{
            backgroundColor: '#007bff',
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: 4,
            padding: '8px 16px'
          }}
          onClick={handleOpen}
        >
          Intervista e daljes
        </Button>
      )}

      <Modal
        open={isModalOpen}
        onClose={handleClose}
        disableBackdropClick={gateMode}
        disableEscapeKeyDown={gateMode}
        className={classes.modal}
        aria-labelledby='exit-interview-modal'
      >
        <Paper className={classes.paper}>
          {/* Header */}
          <div className={classes.header}>
            <img src={speeex_logo_modal} alt='SPEEEX Logo' className={classes.logo} />
            <Typography className={classes.title}>
              Exit Interview – SPEEEX
            </Typography>
            <Typography className={classes.subtitle}>
              Qëllimi i kësaj interviste të daljes është të kuptojmë më mirë përvojën tuaj në SPEEEX dhe të identifikojmë mundësitë për përmirësim të mjedisit të punës dhe praktikave të brendshme. Ju lutemi që përgjigjet tuaja të jenë sa më transparente dhe të sinqerta. Të gjitha përgjigjet trajtohen në mënyrë konfidenciale.
            </Typography>
          </div>

          {/* Progress Bar */}
          <div className={classes.progressBar}>
            <Typography className={classes.progressText}>
              Progresi: {progress}% i plotësuar ({answeredCount}/{TOTAL_QUESTIONS} pyetje)
            </Typography>
            <div className={classes.progressBarContainer}>
              <div 
                className={classes.progressBarFill}
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>

          {/* Content */}
          <div className={classes.content}>
            <form autoComplete='off' onSubmit={handleSubmit}>
              {Object.entries(sections).map(([sectionTitle, sectionQuestions]) => (
                <div key={sectionTitle} className={classes.section}>
                  {/* <Typography className={classes.sectionTitle}>
                    {sectionTitle}
                  </Typography> */}
                  
                  {sectionQuestions
                    .filter((question) => question.type === 'radio')
                    .map((question, key) => {
                      const answerIndex = RADIO_QUESTIONS.findIndex(
                        (q) => q.inputName === question.inputName,
                      )
                      return (
                        <div key={key} className={classes.question}>
                          <Typography className={classes.questionText}>
                            {question.name}
                          </Typography>
                          {question.useSelect && question.multiSelect ? (
                            <>
                              <FormControl
                                variant="outlined"
                                size="small"
                                className={classes.selectControl}
                                required={question.required}
                              >
                                <InputLabel id={`${question.inputName}-label`}>
                                  Zgjidhni një ose më shumë opsione
                                </InputLabel>
                                <Select
                                  labelId={`${question.inputName}-label`}
                                  id={question.inputName}
                                  name={question.inputName}
                                  multiple
                                  value={
                                    Array.isArray(selectedAnswers[answerIndex])
                                      ? selectedAnswers[answerIndex]
                                      : []
                                  }
                                  onChange={(event) => {
                                    const next = event.target.value
                                    const newSelectedAnswers = [...selectedAnswers]
                                    newSelectedAnswers[answerIndex] = next
                                    setSelectedAnswers(newSelectedAnswers)
                                    const ne = [...selectedAnswersError]
                                    ne[answerIndex] = !next.length
                                    setSelectedAnswersError(ne)
                                    if (
                                      question.otherOptionValue &&
                                      !next.includes(question.otherOptionValue)
                                    ) {
                                      setQ8Other('')
                                      setQ8OtherError(false)
                                    }
                                  }}
                                  input={
                                    <OutlinedInput label="Zgjidhni një ose më shumë opsione" />
                                  }
                                  label="Zgjidhni një ose më shumë opsione"
                                  renderValue={(selected) =>
                                    selected
                                      .map(
                                        (val) =>
                                          question.options.find((o) => o.value === val)?.text,
                                      )
                                      .filter(Boolean)
                                      .join(', ')
                                  }
                                >
                                  {question.options.map((option) => (
                                    <MenuItem key={option.key} value={option.value}>
                                      <Checkbox
                                        color="primary"
                                        size="small"
                                        checked={
                                          Array.isArray(selectedAnswers[answerIndex]) &&
                                          selectedAnswers[answerIndex].indexOf(option.value) > -1
                                        }
                                      />
                                      <ListItemText primary={option.text} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              {question.otherOptionValue &&
                                Array.isArray(selectedAnswers[answerIndex]) &&
                                selectedAnswers[answerIndex].includes(
                                  question.otherOptionValue,
                                ) && (
                                  <TextField
                                    className={classes.textField}
                                    style={{ marginTop: 12 }}
                                    variant="outlined"
                                    label="Specifikoni (Tjetër)"
                                    placeholder="Shkruani arsyen tuaj..."
                                    value={q8Other}
                                    onChange={(e) => {
                                      setQ8Other(e.target.value)
                                      setQ8OtherError(false)
                                    }}
                                    fullWidth
                                    required
                                    size="small"
                                    error={q8OtherError}
                                    helperText={
                                      q8OtherError
                                        ? 'Kjo fushë është e detyrueshme kur zgjidhni Tjetër'
                                        : ''
                                    }
                                  />
                                )}
                            </>
                          ) : question.useSelect ? (
                            <FormControl
                              variant="outlined"
                              size="small"
                              className={classes.selectControl}
                              required={question.required}
                            >
                              <InputLabel id={`${question.inputName}-label`}>
                                Zgjidhni një opsion
                              </InputLabel>
                              <Select
                                labelId={`${question.inputName}-label`}
                                id={question.inputName}
                                name={question.inputName}
                                value={selectedAnswers[answerIndex] || ''}
                                onChange={(event) => handleRadioChange(event, answerIndex)}
                                label="Zgjidhni një opsion"
                              >
                                <MenuItem value="">
                                  <em>Zgjidhni një opsion</em>
                                </MenuItem>
                                {question.options.map((option) => (
                                  <MenuItem key={option.key} value={option.value}>
                                    {option.text}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          ) : (
                            <RadioGroup
                              className={classes.radioGroup}
                              aria-label={question.name}
                              name={question.inputName}
                              value={selectedAnswers[answerIndex]}
                              onChange={(event) => handleRadioChange(event, answerIndex)}
                            >
                              {question.options.map((option) => (
                                <FormControlLabel
                                  key={option.key}
                                  value={option.value}
                                  control={<Radio size="small" color="primary" />}
                                  label={option.text}
                                  className={`${classes.radioOption} ${
                                    selectedAnswers[answerIndex] === option.value
                                      ? classes.radioOptionSelected
                                      : ''
                                  }`}
                                />
                              ))}
                            </RadioGroup>
                          )}
                          {selectedAnswersError[answerIndex] && (
                            <Typography className={classes.errorText}>
                              {question.multiSelect
                                ? 'Ju lutem zgjidhni të paktën një opsion'
                                : 'Ju lutem zgjidhni një opsion'}
                            </Typography>
                          )}
                        </div>
                      )
                    })}
                    
                  {sectionQuestions
                    .filter((question) => question.type === 'text')
                    .map((question, key) => {
                      const answerIndex = TEXT_QUESTIONS.findIndex(
                        (q) => q.inputName === question.inputName,
                      )
                      return (
                        <div key={key} className={classes.question}>
                          <Typography className={classes.questionText}>
                            {question.name}
                          </Typography>
                          <TextField
                            className={classes.textField}
                            variant="outlined"
                            placeholder="Shkruani përgjigjen tuaj këtu..."
                            value={inputAnswers[answerIndex]}
                            onChange={(event) => handleInputChange(event, answerIndex)}
                            fullWidth
                            required={question.required}
                            multiline
                            rows={2}
                            size="small"
                          />
                        </div>
                      )
                    })}
                </div>
              ))}
            </form>
          </div>

          {/* Actions */}
          <div className={classes.actions}>
            {!gateMode && (
              <Button variant='contained' onClick={handleClose} className={classes.cancelButton}>
                Anulo
              </Button>
            )}
            <Button type='submit' variant='contained' className={classes.submitButton} onClick={handleSubmit}>
              Dërgo
            </Button>
          </div>
        </Paper>
      </Modal>
    </div>
  )
}

export default ResignIntervieModal
